// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import { store } from './store';
import firebase from 'firebase/app';
import VueSimplemde from 'vue-simplemde';
import 'simplemde/dist/simplemde.min.css';

Vue.use(VueSimplemde);

Vue.use(Vuetify, {
  theme: {
    // primary: '#04368e',
    primary: '#fcbe08',
    secondary: '#032b72',
    accent: '#fcbe08',
    error: '#f44336',
    warning: '#ffeb3b',
    info: '#2196f3',
    success: '#4caf50'
  }
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',

  created() {
    const config = {
      apiKey: 'AIzaSyBsN15mAdA52Lw3MnrBnrAsy7mMagIVBnU',
      authDomain: 'guardians-of-dreams.firebaseapp.com',
      databaseURL: 'https://guardians-of-dreams.firebaseio.com',
      projectId: 'guardians-of-dreams',
      storageBucket: 'guardians-of-dreams.appspot.com',
      messagingSenderId: '956847479003'
    };
    firebase.initializeApp(config);
  }
});



// WEBPACK FOOTER //
// ./src/main.js